<script>
import Sidebar from '@wielink-application/shared/vue/layouts/partials/sidebar.vue'
export default Sidebar;
</script>